module.exports = "<div [id]=\"targetDiv\"></div>"